<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <template v-if="errorResponse === null">
        <p>
          Great job, you're almost done!
        </p>
        <p>
          In order to access the Analytics Dashboard for your workspace, we will need a valid e-mail address to send your temporary password and login URL.  What email address would you like to use as your login?  If you have already created a dashboard login, you can safely close this window.
        </p>
      </template>
      <template v-else>
        <p class="text-danger">
          Error creating account: {{ errorMessage }}
        </p>
        <p>
          Please try again.  What email address would you like to use as your login?
        </p>

      </template>
    </b-card-text>

    <b-form @submit="nextButtonClick">
      <b-form-group>

        <b-form-input type="text" placeholder="Account Email Address" ref="emailAddress" v-model="accountEmail" v-on:blur="accountEmailBlurred = true"></b-form-input>
      </b-form-group>

      <template v-if="dashboardEmailDataLoaded && dashboardEmailData.status != 200">
        <b-alert variant="danger" show>{{ dashboardEmailData.data.message }}</b-alert>
      </template>

      <b-button :disabled="accountEmail.length < 6" class="float-right" type="submit" variant="primary">Next</b-button>
    </b-form>
  </div>
</template>


<script>
export default {
  name: 'Step3',

  data: function() {
    return {
      accountEmail: '',
      accountEmailBlurred: false,
    }
  },

  computed: {
    dashboardEmailDataLoaded() {
      return this.$store.state.dashboardEmailDataLoaded
    },
    dashboardEmailData() {
      return this.$store.state.dashboardEmailData
    },

    errorResponse() {
      return this.$store.state.errorResponse
    },
    errorMessage() {
      return this.$store.state.errorResponse.data.message
    }
  },

  methods: {
    nextButtonClick(e) {
      e.preventDefault()
      console.log(this.accountEmail)
      this.$store.dispatch('submitDashboardLoginEmail', this.accountEmail)
    }
  },

  mounted() {
    this.$store.commit('installProgress', 75)
  }
}
</script>